import { computed, ref } from 'vue'
import { each, pick, toArray } from 'lodash'

export function usePersonFullname() {
	function personBuildFullname(
		person: Api.User | Api.Person | Api.Team | string,
		options?: { isTeam: boolean }
	) {
		const defaultOptions = { salutation: true, title: true, isTeam: false }
		const fullConfig = { ...defaultOptions, ...options }

		const reactivePerson = ref(person)

		const fullName = computed(() => {
			const properties = fullConfig.isTeam
				? ['first_name', 'last_name']
				: ['firstname', 'lastname']

			if (fullConfig.title && !fullConfig.isTeam) properties.unshift('title')
			if (fullConfig.salutation) properties.unshift('salutation')

			let currentPerson = reactivePerson.value

			if (!currentPerson) {
				return undefined
			}

			if (typeof currentPerson === 'object') {
				if (
					Object.prototype.hasOwnProperty.call(currentPerson, 'team') &&
					fullConfig.isTeam
				) {
					currentPerson = currentPerson.team
				}
				if (
					Object.prototype.hasOwnProperty.call(currentPerson, 'persons') &&
					!fullConfig.isTeam
				) {
					currentPerson =
						Array.isArray(currentPerson.persons) &&
						currentPerson.persons.length > 0
							? currentPerson.persons[0]
							: {}
				}
				if (
					Object.prototype.hasOwnProperty.call(currentPerson, 'person') &&
					!fullConfig.isTeam
				) {
					currentPerson = currentPerson.person
				}
				each(properties, (property) => {
					if (!Object.prototype.hasOwnProperty.call(currentPerson, property)) {
						return false
					}
				})
				return toArray(pick(currentPerson, properties))
					.filter(Boolean)
					.join(' ')
			}

			if (typeof currentPerson === 'string') {
				return currentPerson
			}

			return undefined
		})
		return fullName.value
	}
	return { personBuildFullname }
}
